import { QueryClient } from '@tanstack/react-query'
import { RESOURCE_INVALIDATION_CONFIG } from './realtimeInvalidationConfig'

export interface RealtimeEventMessage {
  type: 'resource.updated' | 'resource.created' | 'resource.deleted'
  business_slug?: string
  resource?: string | null
  resource_id?: number | null
  action?: string | null
  event_id?: number | null
  client_mutation_id?: string | null
}

const isValidResourceId = (resourceId: number | null | undefined): resourceId is number =>
  typeof resourceId === 'number'

export const invalidateForRealtimeEvent = async (
  queryClient: QueryClient,
  message: RealtimeEventMessage
) => {
  const { business_slug: slug, resource, resource_id: resourceId } = message
  if (!slug || !resource || !isValidResourceId(resourceId)) return

  const config = RESOURCE_INVALIDATION_CONFIG[resource]
  if (!config) return

  await Promise.all(
    config.listRoots(slug).map(queryKey => queryClient.invalidateQueries({ queryKey }))
  )

  const detailKey = config.detail?.(slug, resourceId)
  if (detailKey) {
    await queryClient.invalidateQueries({ queryKey: detailKey, exact: true })
  }

  await Promise.all(
    (config.extraInvalidationKeys?.(slug, resourceId) ?? []).map(queryKey =>
      queryClient.invalidateQueries({ queryKey, exact: true })
    )
  )
}
